import { 
  CREATE_PERSONALIZATION_LEAD_REQUEST, CREATING_PERSONALIZATION_LEAD_SUCCEEDED, CREATING_PERSONALIZATION_LEAD_FAILED,
  UPLOAD_LEADS_FOR_PERSONALIZATION_REQUEST,
  UPLOADING_LEADS_FOR_PERSONALIZATION_SUCCEEDED,
  UPLOADING_LEADS_FOR_PERSONALIZATION_FAILED,
  FETCHING_PERSONALIZATION_LEADS_REQUEST,
  FETCHING_PERSONALIZATION_LEADS_SUCCEDED,
  FETCHING_PERSONALIZATION_LEADS_FAILED,
  UPDATING_PERSONALIZATION_FAILED,
  UPDATING_PERSONALIZATION_SUCCEEDED,
  UPDATE_PERSONALIZATION_REQUEST,
  DELETE_PERSONALIZATION_REQUEST,
  DELETING_PERSONALIZATION_FAILED,
  DELETING_PERSONALIZATION_SUCCEEDED,
  FETCHING_PERSONALIZATION_LINKS_REQUEST,
  FETCHING_PERSONALIZATION_LINKS_SUCCEDED,
  FETCHING_PERSONALIZATION_LINKS_FAILED,
  INVALIDATE_PERSONALIZATION_LEADS,
  FETCHING_PERSONALIZATION_CONTACTS,
  FETCHING_PERSONALIZATION_CONTACTS_SUCCEEDED,
  FETCHING_PERSONALIZATION_CONTACTS_FAILED,
  CREATE_PERSONALIZED_ALIAS_REQUEST,
  CREATING_PERSONALIZED_ALIAS_SUCCEDED,
  CREATING_PERSONALIZED_ALIAS_FAILED,
  UPDATE_PERSONALIZATION_ALIAS_REQUEST,
  UPDATING_PERSONALIZATION_ALIAS_SUCCEEDED,
  UPDATING_PERSONALIZATION_ALIAS_FAILED,
  INVALIDATE_PERSONALIZATION_LEAD_ITEMS,
  INVALIDATE_PERSONALIZATION
} from 'constants/actionTypes';

import { call, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { createAction } from 'redux-actions';
import buildUrl from 'build-url';
import _, { take } from 'lodash';

const apiUrl = process.env.REACT_APP_CLEVERSTORY_API_URL;

const PERSONALIZATION_BASE_URL = `${apiUrl}/api/2.0/personalization`;
const ALIAS_URL = `${apiUrl}/api/2.0/aliases`;
/**
 * create custom leads
*/
export const creatingPersonalizationLead = createAction(CREATE_PERSONALIZATION_LEAD_REQUEST, (storyboard, request, callback) => {
  return {
    storyboard: storyboard,
    request: request,
    callback: callback
  }
});

const creatingPersonalizationLeadSucceeded = createAction(CREATING_PERSONALIZATION_LEAD_SUCCEEDED, (response) => {
  return {
    response: response
  }
});

const creatingPersonalizationLeadFailed = createAction(CREATING_PERSONALIZATION_LEAD_FAILED, (error) => {
  return {
    error: error
  }
})

function* creatingPersonalizationLeadSaga(action) {
  const { storyboard, request, callback } = action.payload;

  const payloadReq = {
    storyboard: storyboard,
    createContactRequests: [request]
  }

  const creatingPersonalizationLeadAPI = () => {
    return axios.post(PERSONALIZATION_BASE_URL, payloadReq).then(response => response.data);
  }

  try {
    const response = yield call(creatingPersonalizationLeadAPI);
    if (response) {

      yield put(creatingPersonalizationLeadSucceeded(response));
      callback()
    }
  } catch (error) {
    yield put(creatingPersonalizationLeadFailed(error));
  }
}



/**
 * Update custom leads
*/
export const updatePersonalization = createAction(UPDATE_PERSONALIZATION_REQUEST, (request) => {
  return {
    request: request
  }
});

const updatingPersonalizationSucceeded = createAction(UPDATING_PERSONALIZATION_SUCCEEDED, (response) => {
  return {
    response: response
  }
});

const updatingPersonalizationFailed = createAction(UPDATING_PERSONALIZATION_FAILED, (error) => {
  return {
    error: error
  }
})

function* updatingPersonalizationSaga(action) {
  const { request } = action.payload;

  const updatingPersonalizationLeadAPI = () => {
    return axios.put(PERSONALIZATION_BASE_URL, request).then(response => response.data);
  }

  try {
    const response = yield call(updatingPersonalizationLeadAPI);
    if (response) {

      yield put(updatingPersonalizationSucceeded(response));
    }
  } catch (error) {
    yield put(updatingPersonalizationFailed(error));
  }
}



export const fetchingPersonalizationContacts = createAction(
  FETCHING_PERSONALIZATION_CONTACTS,
  ( query, page, limit) => ({
    query,
    page,
    limit
  })
);

export const fetchingPersonalizationContactsSucceeded = createAction(
  FETCHING_PERSONALIZATION_CONTACTS_SUCCEEDED,
  (response) => {
    return {
      response: response
    }
  }
);

export const fetchingPersonalizationContactsFailed = createAction(
  FETCHING_PERSONALIZATION_CONTACTS_FAILED,
  (error) => {
    return {
      error: error
    }
  }
);

function* fetchingPersonalizationContactsSaga(action) {
  const { query, page, limit } = action.payload;

  const url = buildUrl(apiUrl, {
    path: `/api/2.0/contacts/all?page=${page}&limit=${limit}`
  });

  const fetchAPI = () => axios.post(url, query).then(res => res.data);

  try {
    const response = yield call(fetchAPI);
    yield put(fetchingPersonalizationContactsSucceeded(response));
  } catch (error) {
    yield put(fetchingPersonalizationContactsFailed(error));
  }
}

/**
 * delete personalization
*/
export const deletePersonalization = createAction(DELETE_PERSONALIZATION_REQUEST, (id) => {
  return {
    id: id
  }
});

const deletingPersonalizationSucceeded = createAction(DELETING_PERSONALIZATION_SUCCEEDED, (deletedId) => {
  return {
    id: deletedId
  }
});

const deletingPersonalizationFailed = createAction(DELETING_PERSONALIZATION_FAILED, (error) => {
  return {
    error: error
  }
})

function* deletingPersonalizationSaga(action) {
  const { id } = action.payload;

  let url = buildUrl(PERSONALIZATION_BASE_URL, {
    path: id
  });

  const deletingPersonalizationLeadAPI = () => {
    return axios.delete(url).then(response => response.data);
  }

  try {
    const response = yield call(deletingPersonalizationLeadAPI);
    if (response) {

      yield put(deletingPersonalizationSucceeded(id));
    }
  } catch (error) {
    yield put(deletingPersonalizationFailed(error));
  }
}



/**
 * Update personalization alias for {id}
*/
export const updatePersonalizationAliases = createAction(UPDATE_PERSONALIZATION_ALIAS_REQUEST, (lead, id, request) => {
  return {
    lead: lead,
    id: id,
    request: request,
  }
})

export const updatePersonalizationAliasSucceeded = createAction(UPDATING_PERSONALIZATION_ALIAS_SUCCEEDED, (lead, id,  response) => {
  return {
    lead: lead,
    id: id,
    response: response
  };
})

export const updatePersonalizationAliasFailed = createAction(UPDATING_PERSONALIZATION_ALIAS_FAILED, (error) => {
  return error;
})

function* updatePersonalizationAliasSaga(action) {
  const { lead, id, request } = action.payload;


  let url = buildUrl(ALIAS_URL, {
    path: `${id}`
  });

  const updatePersonalizationAliasAPI = () => {
    return axios.put(url, request).then(response => response.data);
  }

  try {
    const response = yield call(updatePersonalizationAliasAPI);
    if (response) {
      yield put(updatePersonalizationAliasSucceeded(lead, id, response));
    }
  } catch (error) {
    yield put(updatePersonalizationAliasFailed(error));
  }
}


/**
 * upload workspace  leads
*/
export const uploadingPersonalizationLead = createAction(UPLOAD_LEADS_FOR_PERSONALIZATION_REQUEST, (storyboard, request, callback) => {
  return {
    storyboard: storyboard,
    request: request,
    callback: callback
  }
});

const uploadingPersonalizationLeadSucceeded = createAction(UPLOADING_LEADS_FOR_PERSONALIZATION_SUCCEEDED, (response) => {
  return {
    response: response
  }
});

const uploadingPersonalizationLeadFailed = createAction(UPLOADING_LEADS_FOR_PERSONALIZATION_FAILED, (error) => {
  return {
    error: error
  }
})

function* uploadingPersonalizationLeadSaga(action) {
  const { storyboard, request, callback } = action.payload;

  const payloadReq = {
    storyboard: storyboard,
    ...request
  }

  const uploadingPersonalizationLeadAPI = () => {
    return axios.post(PERSONALIZATION_BASE_URL, payloadReq).then(response => response.data);
  }

  try {
    const response = yield call(uploadingPersonalizationLeadAPI);
    if (response) {

      yield put(uploadingPersonalizationLeadSucceeded(response));
      callback()
    }
  } catch (error) {
    yield put(uploadingPersonalizationLeadFailed(error));
  }
}


/**
 * fetch personalizationleads leads
*/
export const fetchPersonalizationLead = createAction(FETCHING_PERSONALIZATION_LEADS_REQUEST, (request, page, limit) => {
  return {
    request: request,
    page: page,
    limit: limit
  }
});

const fetchingPersonalizationLeadSucceeded = createAction(FETCHING_PERSONALIZATION_LEADS_SUCCEDED, (response) => {
  return {
    response: response
  }
});

const fetchingPersonalizationLeadFailed = createAction(FETCHING_PERSONALIZATION_LEADS_FAILED, (error) => {
  return {
    error: error
  }
})

function* fetchingPersonalizationLeadSaga(action) {
  const { request, page, limit } = action.payload;

  let url = buildUrl(PERSONALIZATION_BASE_URL, {
    path: `/all?page=${page}&limit=${limit}`
  });

  const fetchingPersonalizationLeadAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(fetchingPersonalizationLeadAPI);
    if (response) {

      yield put(fetchingPersonalizationLeadSucceeded(response));
    }
  } catch (error) {
    yield put(fetchingPersonalizationLeadFailed(error));
  }
}

/**
 * create personalized links
*/
export const createPersonalizedAliases = createAction(CREATE_PERSONALIZED_ALIAS_REQUEST, (request) => {
  return {
    request: request,
  }
})

export const createPersonalizedAliasSucceeded = createAction(CREATING_PERSONALIZED_ALIAS_SUCCEDED, (response) => {
  return {
    response: response
  };
})

export const createPersonalizedAliasFailed = createAction(CREATING_PERSONALIZED_ALIAS_FAILED, (error) => {
  return error;
})

function* createPersonalizedAliasSaga(action) {
  const { request } = action.payload;

  const createPersonalizedAliasAPI = () => {
    return axios.post(ALIAS_URL, request).then(response => response.data);
  }

  try {
    const response = yield call(createPersonalizedAliasAPI);
    if (response) {
      yield put(createPersonalizedAliasSucceeded(response));
    }
  } catch (error) {
    yield put(createPersonalizedAliasFailed(error));
  }
}



/**
 * fetch personalizationleads links
*/
export const fetchPersonalizationLink = createAction(FETCHING_PERSONALIZATION_LINKS_REQUEST, (id, page, limit) => {
  return {
    id:id,
    page: page,
    limit: limit
  }
});

const fetchingPersonalizationLinkSucceeded = createAction(FETCHING_PERSONALIZATION_LINKS_SUCCEDED, (id, response) => {

  return {
    id: id,
    response: response
  }
});

const fetchingPersonalizationLinkFailed = createAction(FETCHING_PERSONALIZATION_LINKS_FAILED, (error) => {
  return {
    error: error
  }
})

function* fetchingPersonalizationLinkSaga(action) {
  const { id, page, limit } = action.payload;

  const request = {
    personalization: id,
  }

  let url = buildUrl(ALIAS_URL, {
    path: `/personalization?page=${page}&limit=${limit}`
  });

  const fetchingPersonalizationLinkAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(fetchingPersonalizationLinkAPI);
    if (response) {
      yield put(fetchingPersonalizationLinkSucceeded(id, response));
    }
  } catch (error) {
    yield put(fetchingPersonalizationLinkFailed(error));
  }
}

export const invalidatePersonalizationState = createAction(INVALIDATE_PERSONALIZATION_LEADS, (type) => {

  return {
    type: type
  }
});

export const invalidatePersonalization = createAction(INVALIDATE_PERSONALIZATION);


export default function* personalizationSaga() {
  yield takeEvery(CREATE_PERSONALIZATION_LEAD_REQUEST, creatingPersonalizationLeadSaga);
  yield takeEvery(FETCHING_PERSONALIZATION_CONTACTS, fetchingPersonalizationContactsSaga);
  yield takeEvery(UPDATE_PERSONALIZATION_REQUEST, updatingPersonalizationSaga);
  yield takeEvery(UPDATE_PERSONALIZATION_ALIAS_REQUEST, updatePersonalizationAliasSaga);
  yield takeEvery(UPLOAD_LEADS_FOR_PERSONALIZATION_REQUEST, uploadingPersonalizationLeadSaga);
  yield takeEvery(FETCHING_PERSONALIZATION_LEADS_REQUEST, fetchingPersonalizationLeadSaga);
  yield takeEvery(FETCHING_PERSONALIZATION_LINKS_REQUEST, fetchingPersonalizationLinkSaga);
  yield takeEvery(CREATE_PERSONALIZED_ALIAS_REQUEST, createPersonalizedAliasSaga);
  yield takeEvery(DELETE_PERSONALIZATION_REQUEST, deletingPersonalizationSaga);
}